import { render, staticRenderFns } from "./wardUser.vue?vue&type=template&id=668d2d1f&scoped=true&"
import script from "./wardUser.vue?vue&type=script&lang=js&"
export * from "./wardUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d2d1f",
  null
  
)

export default component.exports